// extracted by mini-css-extract-plugin
module.exports = {"text1":"FootPrintVsCompensationText_text1__I44GJ","text2":"FootPrintVsCompensationText_text2__COa2B"};